import { useHistory, useParams } from "react-router-dom";
import Hostname from "../../hooks/Hostname";
import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import PanToolOutlinedIcon from '@mui/icons-material/PanToolOutlined';

const MobileHome = () => {
  const history = useHistory();
  const { orgId } = useParams();
  const host = Hostname();

  return (
    <div className="mobile-home-page">
      <p className="mobile-header-notice">
        Dit is de mobiele versie van {host.Name}. De volledige functionaliteit is
        beschikbaar op desktop.
      </p>
      <div className="mobile-home-tile-container" onClick={() => history.push(`/${orgId}/mycalendar`)}>
        <h2>Mijn agenda</h2>
        <PermContactCalendarOutlinedIcon/>
      </div>

      <div className="mobile-home-tile-container" onClick={() => history.push(`/${orgId}/fullcalendar`)}>
        <h2>Complete agenda</h2>
        <CalendarMonthOutlinedIcon/>
      </div>

      <div className="mobile-home-tile-container" onClick={() => history.push(`/${orgId}/myhouseholds`)}>
        <h2>Mijn huishoudens</h2>
        <HomeWorkOutlinedIcon/>
      </div>

      {/* Naast 'Mijn huishoudens': wat aan jou is toegewezen tegenover wat er
          nog vrij ligt. Zie docs/features/huishouden-zelf-op-te-pakken.md */}
      <div className="mobile-home-tile-container" onClick={() => history.push(`/${orgId}/pickuphouseholds`)}>
        <h2>Zelf op te pakken</h2>
        <PanToolOutlinedIcon/>
      </div>
    </div>
  );
};

export default MobileHome;
